import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetIsSubscribed = (subscriberId: string, subscriberType: number, targetId: string, targetType: string, t?: any) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!subscriberId || !targetId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.subscriptions)
            .url('/api/Subscription/CheckSubscription')
            .get()
            .addQuery('subscriberId', subscriberId)
            .addQuery('subscriberType', subscriberType)
            .addQuery('targetId', targetId)
            .addQuery('targetType', targetType)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [subscriberId, subscriberType, targetId, targetType, t])

    return {isSubscribed: resp || false, isLoading, error};
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetIsSubscribed = (subscriberId: string, subscriberType: number, targetId: string, targetType: string, t?: any) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!subscriberId || !targetId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.subscriptions)
            .url('/api/Subscription/CheckSubscription')
            .get()
            .addQuery('subscriberId', subscriberId)
            .addQuery('subscriberType', subscriberType)
            .addQuery('targetId', targetId)
            .addQuery('targetType', targetType)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [subscriberId, subscriberType, targetId, targetType, t])

    return {isSubscribed: resp || false, isLoading, error};
}